export const CREATE_USER = 'CREATE_USER';
export const CREATE_FORUMS = 'CREATE_FORUMS';
export const CREATE_PARTNERS = 'CREATE_PARTNERS';
